/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteAccountDto } from '../models/DeleteAccountDto';
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { UserEntity } from '../models/UserEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * Update an entity
     * @param requestBody
     * @returns UserEntity
     * @throws ApiError
     */
    public static usersControllerUpdateV1(
        requestBody: UpdateUserDto,
    ): CancelablePromise<UserEntity> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Permanently delete the authenticated user account
     * Hard-deletes the user, scrubs the personal attributes off their RevenueCat customer (purchase history is retained), purges uploaded GCS files, revokes every device session, and removes any solo-owned business. Billing rows survive with their owner set to NULL. Blocked with 409 if the user owns a business that has other members.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static usersControllerDeleteAccountV1(
        requestBody: DeleteAccountDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/users/account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Owner of a multi-member business`,
            },
        });
    }
}
